// extracted by mini-css-extract-plugin
module.exports = {"TheComp":"CardB1_TheComp__Hj_nI"};